import { useMemo, useState } from "react"
//Material UI
import InputNumber from "#core/components/input/number/InputNumber"
import InputSelect from "#core/components/input/select/InputSelect"
import { useApi } from "#hooks/useApi"
import { useApiSend } from "#hooks/useApiSend"
import { loanIdPut, loanMethodPayGet } from "#loan/services/api"
import { Box, Button } from "@mui/material"
import Checkbox from "@mui/material/Checkbox"
import { InputDate } from "#common/input/InputDate"
import dayjs from "dayjs"
import { DialogMaster } from "#core/components/dialog/Dialog"
import CircularSkeleton from "#common/skeleton/CircularSkeleton"
import ErrorResponse from "#core/pages/ErrorResponse"
import { useRefreshLoan } from "#loan/redux/actions"
import { STATUS } from "#loan/constants"

export function LoanEdit({ loan, reload }) {
	const params = useMemo(() => ({ all: true }), [])
	const { data, loading, error } = useApi(loanMethodPayGet, { autoFetch: true, params })
	const method_pay = useMemo(() => data?.data || [], [data])

	if (loading) return <CircularSkeleton />
	if (error) return <ErrorResponse api={error} />

	const displayInterest = ![
		STATUS.VALIDATE_RH,
		STATUS.PROCESS,
		STATUS.VALIDATE_BOSS,
	].includes(loan?.status)

	return (
		<Box sx={{ display: "flex", flexDirection: "column", gap: 2, width: "100%" }}>
			<LoanEditNumber
				label="Cantidad del préstamo"
				field="cantidad"
				id={loan?.id}
				defaultValue={loan?.cantidad}
				reload={reload}
			/>
			<LoanEditSelect
				label="Método de pago"
				field="metodo_pago"
				id={loan?.id}
				defaultValue={loan?.metodo_pago}
				data={method_pay}
				reload={reload}
			/>
			{displayInterest && (
				<LoanEditNumber
					label="Interés del préstamo %"
					field="interest"
					id={loan?.id}
					defaultValue={loan?.interest}
					reload={reload}
				/>
			)}
			{displayInterest && (
				<LoanEditDate
					label="Fecha de pago"
					field="day_payment"
					id={loan?.id}
					defaultValue={loan?.day_payment}
					reload={reload}
				/>
			)}
		</Box>
	)
}

export const LoanEditDialog = ({ loan, open, setOpen, reload }) => {
	return (
		<DialogMaster title="editar préstamo" {...{ open, setOpen, maxWidth: "sm" }}>
			<LoanEdit loan={loan} reload={reload} />
		</DialogMaster>
	)
}

const LoanEditItemBase = ({
	id,
	field,
	label,
	defaultValue,
	InputComponent = InputNumber,
}) => {
	const { refresh } = useRefreshLoan()
	const [checked, setChecked] = useState(false)
	const [value, setValue] = useState(defaultValue)
	const [disabled, setDisabled] = useState(false)

	const success = () => {
		refresh()
		setChecked(false)
	}
	const end = () => {
		setDisabled(false)
	}
	const { fetch } = useApiSend(loanIdPut, { success, end })

	const handleFetch = () => {
		setDisabled(true)
		fetch(id, {
			[field]: value,
		})
	}

	return (
		<Box sx={{ display: "flex", gap: 1, width: "100%", alignItems: "center" }}>
			<InputComponent
				disabled={!checked}
				{...{ label, value, setValue }}
				sx={{ flex: 1 }}
			/>

			<Checkbox
				onChange={(event) => {
					setChecked(event.target.checked)
					setValue(defaultValue)
				}}
				name="method"
				checked={checked}
			/>
			{checked && (
				<Button onClick={handleFetch} disabled={disabled}>
					enviar
				</Button>
			)}
		</Box>
	)
}
const LoanEditNumber = (props) => {
	return <LoanEditItemBase {...{ ...props, InputComponent: InputNumber }} />
}

const LoanEditSelect = ({ data, ...props }) => {
	const InputComponent = ({ ...props }) => {
		return (
			<InputSelect
				options={data || []}
				{...props}
				optionsLabel="descripcion"
				optionsId="id"
			/>
		)
	}

	return <LoanEditItemBase {...{ ...props, InputComponent }} />
}
const LoanEditDate = (props) => {
	const value = dayjs(props.defaultValue, "D-M-YYYY")
	const InputComponent = (props) => {
		return <InputDate onChange={(date) => props.setValue(date)} fullWidth {...props} />
	}

	return <LoanEditItemBase {...{ ...props, defaultValue: value, InputComponent }} />
}
